module.exports = __webpack_public_path__ + "img/img10.938f96ee.png";